import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  clientReferralList: {
    requesting: false,
    items: [],
    contactStatusOptions: [],
    pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
    error: null,
    success: false,
    filters: {},
  },
  clientReferralDetails: {
    requesting: false,
    data: null,
    error: null,
    success: false,
  },
}

export const clientReferralSlice = createSlice({
  name: 'clientReferral',
  initialState,
  reducers: {
    getClientReferralList: (state, action) => {
      state.clientReferralList.requesting = true
      state.clientReferralList.error = null
      state.clientReferralList.items = []
      state.clientReferralList.success = false
      state.clientReferralList.filters = action.payload
    },
    getClientReferralListSuccess: (state, action) => {
        const {data, current_page, per_page, total, contact_status_options,} = action.payload;
        state.clientReferralList.requesting = false;
        state.clientReferralList.items = data ?? [];
        state.clientReferralList.contactStatusOptions = contact_status_options ?? [];
        
        state.clientReferralList.pagination.current_page = current_page;
        state.clientReferralList.pagination.per_page = per_page;
        state.clientReferralList.pagination.total = total;
        state.clientReferralList.success = true;
    },
    getClientReferralListFail: (state, action) => {
      state.clientReferralList.requesting = false
      state.clientReferralList.error = action.payload
    },
    getClientReferralDetails: (state) => {
      state.clientReferralDetails.requesting = true
      state.clientReferralDetails.error = null
      state.clientReferralDetails.data = null
      state.clientReferralDetails.success = false
    },
    getClientReferralDetailsSuccess: (state, action) => {
      state.clientReferralDetails.requesting = false
      state.clientReferralDetails.data = action.payload
      state.clientReferralDetails.success = true
    },
    getClientReferralDetailsFail: (state, action) => {
      state.clientReferralDetails.requesting = false
      state.clientReferralDetails.error = action.payload
    },
    doClientReferralCreate: (state) => {
      state.clientReferralDetails.requesting = true
      state.clientReferralDetails.error = null
      state.clientReferralDetails.data = null
      state.clientReferralDetails.success = false
    },
    doClientReferralCreateSuccess: (state, action) => {
      state.clientReferralDetails.requesting = false;
      state.clientReferralDetails.data = action.payload;
      state.clientReferralDetails.success = true;
    },
    doClientReferralCreateFail: (state, action) => {
      state.clientReferralDetails.requesting = false;
      state.clientReferralDetails.error = action.payload;
      state.clientReferralDetails.success = false;
    },
    doClientReferralUpdate: (state) => {
      state.clientReferralDetails.requesting = true
      state.clientReferralDetails.error = null
      state.clientReferralDetails.data = null
      state.clientReferralDetails.success = false
    },
     doClientReferralUpdateSuccess: (state, action) => {
      state.clientReferralDetails.requesting = false;
      state.clientReferralDetails.data = action.payload;
      state.clientReferralDetails.success = true;
    },
    doClientReferralUpdateFail: (state, action) => {
      state.clientReferralDetails.requesting = false;
      state.clientReferralDetails.error = action.payload;
      state.clientReferralDetails.success = false;
    },
    doClientReferralDelete: (state) => {
      state.clientReferralDetails.requesting = true
      state.clientReferralDetails.error = null
      state.clientReferralDetails.data = null
      state.clientReferralDetails.success = false
    },
    doClientReferralReset: (state) => {
      state.clientReferralDetails.data = null
    },
    resetClientReferralFilters(state) {
      state.clientReferralList.filters = {};
    }
  },
})

export const {
  getClientReferralList,
  getClientReferralListSuccess, doClientReferralCreateSuccess,
  getClientReferralListFail, doClientReferralCreateFail,
  getClientReferralDetails, getClientReferralDetailsSuccess,
  getClientReferralDetailsFail, doClientReferralCreate,
  doClientReferralUpdateSuccess, doClientReferralUpdateFail,
  doClientReferralUpdate, doClientReferralDelete,
  doClientReferralReset, resetClientReferralFilters
} = clientReferralSlice.actions

export default clientReferralSlice.reducer
